/**
 * /:wsId/p/:pKey/members — share this project with someone. Lists current
 * project members and pending email invites. Lead/admin can change roles
 * or revoke.
 *
 * The body lives in `BoardMembersPanel`, which the board settings
 * "Members" tab uses as well.
 */

import { useNavigate, useParams } from '@tanstack/react-router'
import { useProjectByKey } from '@/features/projects/board'
import { BoardMembersPanel } from '@/components/workspace/BoardMembersPanel'

export function ProjectMembersView() {
  const { wsId, pKey } = useParams({ strict: false }) as { wsId: string; pKey: string }
  const navigate = useNavigate()
  const projectQ = useProjectByKey(wsId, pKey)
  const project = projectQ.data

  if (projectQ.isLoading || !project) {
    return (
      <div className="flex h-full items-center justify-center text-sm text-surface-500">
        Loading project…
      </div>
    )
  }

  return (
    <div className="flex h-full flex-col">
      <header className="flex items-center gap-2 border-b border-surface-200 dark:border-surface-700 bg-white/60 dark:bg-surface-900/60 backdrop-blur px-4 md:pr-14 py-2">
        <button
          onClick={() => navigate({ to: '/w/$wsId/p/$pKey', params: { wsId, pKey } })}
          className="rounded p-1 text-surface-500 hover:bg-surface-100 dark:hover:bg-surface-800"
          title="Back to board"
        >
          ←
        </button>
        <h1 className="text-sm font-semibold">
          Share · {project.key} · {project.name}
        </h1>
      </header>

      <div className="flex-1 overflow-auto p-4">
        <BoardMembersPanel wsId={wsId} project={project} />
      </div>
    </div>
  )
}
